import React, { useEffect, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";
import {
  WhereHouseList,
  DeleteWhereHouse,
  WhereHouseChangeStatus,
} from "../../../redux/services/WhereHouseService/wherehouse.Services";
import Pagination from "../../../common/Pagination";
import Swal from "sweetalert2";

function AllWhereHouseList() {
  const dispatch = useDispatch();
  const naviagte=useNavigate();
  const [totalRecords, setTotalRecords] = useState(0);
  const [whereHouse, setWhereHouse] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const refreshData = useSelector((state) => state.productModal.refreshData);
  const [loading, setLoading] = useState(false);
  const fetchWhereHouselist = async () => {
    try {
      setLoading(true);
      const payload = {
        page,
        search,
        status,
      };
      const res = await WhereHouseList(payload);
      setWhereHouse(res?.data || []);
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWhereHouselist();
  }, [page, search, status, refreshData]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">WhereHouse List</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All WhereHouse </span>
              </nav>
            </div>
          </div>

          <button
            className="add-btn"
            onClick={() =>
              dispatch(
                openProductModal({
                  type: "create-wherehouse",
                  title: "Create WhereHouse",
                  data: {
                    refreshData: fetchWhereHouselist,
                  },
                }),
              )
            }
          >
            + Add WhereHouse
          </button>
        </div>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search WhereHouse..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th className="flex-nowrap">Warehouse Name</th>
                  <th className="flex-nowrap">Warehouse Code</th>
                  <th>Manager Name</th>
                  <th>Contact Number</th>
                  <th>Invoice Number</th>
                  {/* <th>Adders</th>  */}
                  {/* <th>Status</th> */}
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {whereHouse.length > 0 ? (
                  whereHouse.map((item, index) => (
                    <tr key={item.id}>
                        <td> {(page - 1) * limit + index + 1}</td>
                      <td className="flex-nowrap">{item.warehouse_name}</td>
                      <td >{item.warehouse_code}</td>
                      <td>{item.manager_name}</td>
                      <td>{item.contact_number}</td>
                      <td>{item.invoice_number}</td>
                      {/* <td>{item.address}</td> */}
                      {/* <td>{item.status === 1 ? "Active" : "Inactive"}</td> */}
                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item._id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status: item.status ? "Active" : "Inactive",
                                    statusFunction: WhereHouseChangeStatus,
                                    onSuccess: fetchWhereHouselist,
                                  },
                                })
                              )
                            }
                          />
                          <label
                            htmlFor={`status-${item._id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>
                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            // onClick={() =>
                            //   dispatch(
                            //     openProductModal({
                            //       type: "view-wherehouse",
                            //       title: "View WhereHouse",
                            //       data: item,
                            //     })
                            //   )
                            // }
                                onClick={() =>
                            naviagte(`/view-wherehouse-list/${item.id}`)
                            }
                          >
                            <FaEye />
                          </button>
                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "edit-wherehouse",
                                  title: "Edit WhereHouse",
                                  data: {
                                    ...item,
                                    refreshData: fetchWhereHouselist,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-wherehouse",
                                  title: "Delete WhereHouse",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteWhereHouse,
                                    refreshData: fetchWhereHouselist,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllWhereHouseList;
